import React from "react";
import PropTypes from "prop-types";

const Burger = ({ className, color }) => {
  switch (color) {
    case `dark-green`:
      color = `#006855`;

      break;

    case `orange`:
    default:
      color = `#EF5518`;
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 30 21">
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="square"
      >
        <g
          id="Mobile_navigation"
          transform="translate(-307.000000, -5.000000)"
          stroke="#EF5518"
          strokeWidth="3"
        >
          <g id="Group">
            <g transform="translate(309.000000, 6.000000)">
              <path d="M-5.32907052e-15,9.5 L26,9.5" id="Line"></path>
              <path d="M-5.32907052e-15,18.5 L26,18.5" id="Line"></path>
              <path d="M0,0.5 L26,0.5" id="Line-Copy"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Burger.defaultProps = {
  className: ``,
  color: `orange`
};

Burger.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default Burger;
